import {HTMLAttributes, ReactNode} from 'react'
import {Container} from '@components/ui/container'
import {cn} from '@utilities/helpers'

export const AuthPageContainer = ({children}: {children: ReactNode}) => (
    <div className="h-full">
        <Container className="flex min-h-full items-center justify-center py-20">{children}</Container>
    </div>
)

export const AuthFormCard = ({className, ...props}: HTMLAttributes<HTMLFormElement>) => (
    <form
        className={cn(
            'flex w-full min-h-auto flex-col items-stretch justify-center gap-14 rounded-lg border border-neutral-300 bg-white p-4',
            'md:min-h-[550px] md:w-[550px] md:py-14 md:px-20',
            className
        )}
        {...props}
    />
)

export const AuthFormCardTitle = ({className, ...props}: HTMLAttributes<HTMLHeadingElement>) => (
    <h1 className={cn('text-display-sm text-center font-medium', className)} {...props} />
)

export const AuthFormCardSubtitle = ({className, ...props}: HTMLAttributes<HTMLHeadingElement>) => (
    <h2 className={cn('text-xs text-center text-neutral-500', className)} {...props} />
)
